// date-format.service.ts

import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class DateFormatService {
  formatDateTime(dateTimeString: string, outputFormat: string): string {
    const formattedDate = moment(dateTimeString).format(outputFormat);
    return formattedDate;
  }
  minutesToTimeDisplay(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    const result = `${String(hours).padStart(2, '0')}h:${String(
      remainingMinutes
    ).padStart(2, '0')}min`;
    return result;
  }
  minutesToTime(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(
      remainingMinutes
    ).padStart(2, '0')}`;
  }

  timeToMinutes(time: string): number {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }

  formatUtcDate(utcDate: string, format: string): string {
    return moment.utc(utcDate).format(format);
  }
  formatDateOnly(date: string, format: string): string {
    return moment(date).format(format);
  }
  hoursToMinutes(hours: number): number {
    return hours * 60;
  }

  minutesToHours(minutes: number): number {
    return Math.floor(minutes / 60);
  }
  convertHourTimeToMinutes(time: string): number {
    const [hoursStr, minutesStr] = time.split(':');
    const hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);

    return hours * 60 + minutes;
  }
}
